import LocalizedStrings from 'localized-strings';

import { InvoiceType } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    addClient: 'Add a client',
    clientName: 'Client name',
    description: 'Description (optional)',
    select: 'Select',
    startAt: 'Issue date',
    [InvoiceType.Quote]: {
      fiscalId: 'Quote number',
      fiscalIdHelp: {
        link: 'how to number your quotes',
        text: 'You can add the number of your quote right before you send it. Find out more about\xa0',
      },
      title: 'Quote title',
    },
    [InvoiceType.Invoice]: {
      fiscalId: 'Invoice number',
      fiscalIdHelp: {
        link: 'how to number your invoices',
        text: 'You can add the number of your invoice right before you send it. Find out more about\xa0',
      },
      title: 'Invoice title',
    },
  },
  fr: {
    addClient: 'Ajouter un client',
    clientName: 'Nom du client',
    description: 'Description (optionnelle)',
    select: 'Sélectionnez',
    startAt: 'Date d’émission',
    [InvoiceType.Quote]: {
      fiscalId: 'Numéro du devis',
      fiscalIdHelp: {
        link: 'la numérotation de vos devis',
        text: 'Vous pourrez ajouter le numéro de votre devis juste avant son envoi. En savoir plus sur\xa0',
      },
      title: 'Titre du devis',
    },
    [InvoiceType.Invoice]: {
      fiscalId: 'Numéro de la facture',
      fiscalIdHelp: {
        link: 'la numérotation de vos factures',
        text: 'Vous pourrez ajouter le numéro de votre facture juste avant son envoi. En savoir plus sur\xa0',
      },
      title: 'Titre de la facture',
    },
  },
} as const);

export default locales;
